import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import {User} from '@models/user';
import {environment} from '~/environments/environment';
import {EMPTY_USER} from '@models/empty';
import {Affiliate, AFFILIATE} from '@models/partner';

declare const mixpanel: any;

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {
    private currentTokenSubject: BehaviorSubject<string>;
    public currentUser: User = Object.assign({}, EMPTY_USER);

    constructor(private http: HttpClient,) {
        this.currentTokenSubject = new BehaviorSubject<string>(localStorage.getItem('token'));
    }

    public get currentUserToken(): string {
        return this.currentTokenSubject.value;
    }

    public get isLogin(): boolean {
        if (this.currentTokenSubject.value) {
            return true;
        }
        return false;
    }

    getTrialDay(): number {
        if (this.currentUser.exclude) {
            return 0;
        }

        if (this.currentUser.pro_plan != '' || (this.currentUser.plan != '' && this.currentUser.plan != 'trial')) {
            return 0;
        }

        let startDate = new Date(this.currentUser.trial_end_date).getTime();
        let days = (startDate - new Date().getTime()) / 86400000;

        if (days > 0) {
            return days;
        }
        return 0;
    }

    showPromo() {
        if (this.currentUser.promo_end_date == "0001-01-01T00:00:00Z") {
            return false;
        }

        if (new Date(this.currentUser.promo_end_date).getTime() >= new Date().getTime() && (this.currentUser.plan == "" || this.currentUser.plan == "trial")) {
            return true;
        }
        return false;
    }

    showHeader() {
        if (this.currentUser.header_form == true || this.isLogin == false) {
            return false;
        }
        // if (this.currentUser.pro_plan != "") {
        //     return false;
        // }
        // if (this.currentUser.plan == "pro") {
        //     return false;
        // }
        // if (this.currentUser.plan == "expert" && this.currentUser.subscription && this.currentUser.subscription.duration == "year") {
        //     return false;
        // }
        return true;
    }

    isInfluenceur(user: User): boolean {
        for (var i = 0; i < AFFILIATE.length; i++) {
            if (AFFILIATE[i].code === user.code_filleul) {
                return true;
            }
        }
        return false;
    }

    getInfluenceurRevenue(user: User): Affiliate {
        for (var i = 0; i < AFFILIATE.length; i++) {
            if (AFFILIATE[i].code === user.code_filleul) {
                return AFFILIATE[i];
            }
        }
    }

    isAffiliate(user: User): boolean {
        for (var i = 0; i < AFFILIATE.length; i++) {
            if (AFFILIATE[i].code === user.code_parrainage) {
                return true;
            }
        }
        return false;
    }

    getInfluenceur(user: User): Affiliate {
        for (var i = 0; i < AFFILIATE.length; i++) {
            if (AFFILIATE[i].code === user.code_parrainage) {
                return AFFILIATE[i];
            }
        }

        return {
                name: '',
                code: '',
                picture: '',
                picture_style: '',
                discount: 0,
                condition: '',
                duration: '',
                commission: 0,
                anonym: false,
        }
    }

    isAllowed(plan): boolean {
        if (!this.isLogin) {
            return false;
        }

        switch (plan) {
            case '':
                return true;
                break;
            case 'basique':
                if (this.currentUser.pro_plan !== '' || this.currentUser.plan === 'trial' || this.currentUser.plan === 'basique' || this.currentUser.plan === 'essentiel' || this.currentUser.plan === 'expert' || this.currentUser.plan === 'gold' || this.currentUser.plan === 'pro') {
                    return true;
                }
                break;
            case 'essentiel':
                if (this.currentUser.pro_plan !== '' || this.currentUser.plan === 'trial' || this.currentUser.plan === 'essentiel' || this.currentUser.plan === 'expert' || this.currentUser.plan === 'gold' || this.currentUser.plan === 'pro') {
                    return true;
                }
                break;
            case 'expert':
                if (this.currentUser.pro_plan !== '' || this.currentUser.plan === 'trial' || this.currentUser.plan === 'expert' || this.currentUser.plan === 'gold' || this.currentUser.plan === 'pro') {
                    return true;
                }
                break;
            case 'gold':
                if (this.currentUser.plan === 'gold') {
                    return true;
                }
                break;
            case 'pro':
                if (this.currentUser.plan === 'pro' || this.currentUser.pro_plan !== '') {
                    return true;
                }
                break;
        }

        return false;
    }

    setUser(user: User) {
        this.currentUser = user;
    }

    loadUser(): Observable<any> {
        if (this.isLogin) {
            return this.http.get<User>(environment.apiUrl + 'app/user', {})
                .pipe(map(user => {
                        this.currentUser = user;
                        if (typeof mixpanel !== 'undefined') {
                            mixpanel.identify(user.email);
                        }
                        return user;
                    },
                    (error) => {
                        console.log(error);
                        this.logout();
                        return null;
                    }));
        } else {
            this.currentUser = Object.assign({}, EMPTY_USER);
            return of(this.currentUser);
        }
    }

    login(username, password, source, code = ''): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}app/login`, {username, password, source, code})
            .pipe(map(data => {
                if (data.message && data.message == "Need2Auth") {

                } else {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('token', data.data.token);
                    this.currentTokenSubject.next(data.data.token);
                    this.setUser(data.data.user);
                }
                return data;
            }));
    }

    loginFacebook(token, code = '', source) {
        return this.http.post<any>(`${environment.apiUrl}app/facebook/login`, {token, code, source})
            .pipe(map(data => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                if (data.data.register == true) {
                }
                localStorage.setItem('token', data.data.token);
                this.currentTokenSubject.next(data.data.token);
                this.setUser(data.data.user);
            }));
    }

    loginGoogle(token, code = '', source) {
        return this.http.post<any>(`${environment.apiUrl}app/google/login`, {token, code, source})
            .pipe(map(data => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                if (data.data.register == true) {
                }
                localStorage.setItem('token', data.data.token);
                this.currentTokenSubject.next(data.data.token);
                this.setUser(data.data.user);

            }));
    }

    logout() {
        // remove user from local storage and set current user to null
        localStorage.removeItem('token');
        this.currentTokenSubject.next('');
        this.setUser(EMPTY_USER);
    }
}
